
  import { useEffect } from "react";

export default function useBlockArrowNavigation() {
  useEffect(() => {
    // Push current page to history stack
    window.history.pushState(null, "", window.location.href);

    // Block back/forward navigation
    const blockPopState = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", blockPopState);

    // Block keyboard arrows (Alt + Left / Right)
    const blockKeys = (e) => {
      if (
        (e.altKey && e.key === "ArrowLeft") ||
        (e.altKey && e.key === "ArrowRight")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", blockKeys);

    return () => {
      window.removeEventListener("popstate", blockPopState);
      window.removeEventListener("keydown", blockKeys);
    };
  }, []);
}
